export const CSRF_COOKIE_NAME = 'csrf-token'
export const CSRF_HEADER_NAME = 'x-csrf-token'

export const API_ENDPOINT_PREFIX = '/@atproto/oauth-provider/~api'
